
import { InputData } from "./input/InputData";
import { PHPResponse } from "./PHPResponse";
import { RandomUIDGenerator } from "../random/RandomUIDGenerator";
import { PHPContext } from "./PHPContext";

export class PHPRequest<A,I extends InputData, R extends PHPResponse>
{
  protected _adress:A;
  
  constructor( adress:A )
  {
    this._adress = adress;
  }
  
  asURL( phpContext:PHPContext, input:I )
  {    
    input.requestID = RandomUIDGenerator.createUID();
    input.pageToken = phpContext.token;

    
    let parameters = InputData.toURLParameters( input );
    
    let url = `${phpContext.path}${this._adress}.php?${parameters}`;
    console.log( "AsURL", input, parameters, url );
    return url;
  }

 
  request( phpContext:PHPContext, input:I, logResponse:boolean = true )
  {
    return this._request( phpContext, input, logResponse, false );
  }

  async call( phpContext:PHPContext, input:I, logResponse:boolean = true ):Promise<void>
  {
    await this._request( phpContext, input, logResponse, true );
    return Promise.resolve();
  }


  private _request( phpContext:PHPContext, input:I, logResponse:boolean = true, isCall:boolean = false ):Promise<R>
  {
    let promise = new Promise<R>(
      ( resolve, reject ) =>
      {  
        let requestURL = phpContext.path + this._adress + ".php";

        input.requestID = RandomUIDGenerator.createUID();
        input.pageToken = phpContext.token;

        if ( logResponse )
        {
          console.log( "REQUESTING: ", requestURL, input );
        }

        var xhttp = new XMLHttpRequest();
        xhttp.open( "POST", requestURL, true );
        xhttp.setRequestHeader( "Content-Type", "application/json");

        let sendingData = JSON.stringify( input );

        xhttp.onerror = ()=>
        {
          console.warn( "ERROR REQUESTING: ", requestURL, input );
          reject();          
        }

        xhttp.onload = ()=>
        {
          if ( isCall )
          {
            resolve( null );
          }

          try
          {
            let responseText = xhttp.responseText;

            
            if ( logResponse )
            { 
              console.log( "LOGGED RESPONSE: ",requestURL, input, "\n",`'${responseText}'` );
            }

            if ( /^\s*\{/.test( responseText ) )
            {
              let jsonObject = JSON.parse( responseText );

              resolve( jsonObject as R );
            }
            else
            {
              console.warn( "REJECTING RESPONSE: ", requestURL, responseText, input );
              reject();
            }
            
          }
          catch( e )
          {
            console.warn( "ERROR PROCESSING RESPONSE: ", requestURL );
            reject();
          }
          
        }
        
        xhttp.send( sendingData );
      }
    );    

    return promise;

  }
}